module.exports = __webpack_public_path__ + "media/images/success-stories-1-cfae5e079e41467ac4bec7149e115ece.jpeg";